module.exports = __webpack_public_path__ + "image/search1.png";